import { CustomFieldData, EntryFieldConditionData } from 'chaika-frontend-types/frontend-cms';
import { EntryTypeFieldType } from 'chaika-enums';

import { axios } from '@lib/axios';

export const CUSTOM_FIELD_BASE_URL = '/api/entry-type/field/custom-field';

interface CustomFieldResponse {
    customField: CustomFieldData;
}

interface CustomFieldListResponse {
    customFields: CustomFieldData[];
}

interface CustomFieldUpdateData {
    version: number;
    conditions: EntryFieldConditionData[];
}

export class CustomFieldApi {
    public static async create(customField: CustomFieldData): Promise<void> {
        await axios.post(CUSTOM_FIELD_BASE_URL, { customField });
    }

    public static async getCustomFieldList(): Promise<CustomFieldData[]> {
        const { data } = await axios.get<CustomFieldListResponse>(CUSTOM_FIELD_BASE_URL);

        return data.customFields;
    }

    public static async getField(fieldType: EntryTypeFieldType): Promise<CustomFieldData> {
        const { data } = await axios.get<CustomFieldResponse>(`${CUSTOM_FIELD_BASE_URL}/${fieldType}`);

        return data.customField;
    }

    public static async update(fieldType: EntryTypeFieldType, customField: CustomFieldUpdateData): Promise<void> {
        await axios.put(`${CUSTOM_FIELD_BASE_URL}/${fieldType}`, { customField });
    }

    public static async delete(fieldType: EntryTypeFieldType): Promise<void> {
        await axios.delete(`${CUSTOM_FIELD_BASE_URL}/${fieldType}`);
    }
}
